import { getRetailerOrder } from './api/retailers';
import { alertError } from './alert';
import { RETAILER_ORDERS_CLOSE_MODAL, RETAILER_ORDERS_MODAL, RETAILER_ORDERS_ORDER } from '../constants/retailerOrders';

export const retailerOrderOpenModal = (open) => ({ type: RETAILER_ORDERS_MODAL, payload: { open } });
export const retailerOrderCloseModal = () => ({ type: RETAILER_ORDERS_CLOSE_MODAL });
export const retailerOrderLoading = (loading) => ({ type: RETAILER_ORDERS_ORDER, payload: { loading } });
export const retailerOrderSetOrder = (order) => ({
  type: RETAILER_ORDERS_ORDER,
  payload: { current: order },
});

export const retailerGetOrder = (order) => async (dispatch, getState) => {
  dispatch(retailerOrderLoading(true));
  dispatch(retailerOrderOpenModal(!!order));

  try {
    const { retailerId } = getState().role;

    const response = await getRetailerOrder(retailerId, order.id);
    const orderInfo = response.data;
    if (orderInfo) {
      order.info = orderInfo;
      dispatch(
        retailerOrderSetOrder({
          ...order,
          ...orderInfo,
        }),
      );
    }
  } catch (error) {
    dispatch(alertError(error));
  } finally {
    dispatch(retailerOrderLoading(false));
  }
};
